module.exports = __webpack_public_path__ + "img/icon-truck.560e5205.svg";